import { VuiGrid, VuiSpacer, VuiText, VuiTextColor } from "../../ui";
import { useConfigContext } from "../../contexts/ConfigurationContext";
import { useChatContext } from "../../contexts/ChatContext";
import { ExampleQuestion } from "./ExampleQuestion";
import "./exampleQuestions.scss";

type Props = {
    questions: Array<string>;
    intro: string;
};

export const ExampleQuestions = ({questions, intro}: Props) => {
  const { exampleQuestions } = useConfigContext();
  const { onSubmitChat } = useChatContext();
  const hasExampleQuestions = exampleQuestions.length > 0;

  if (!hasExampleQuestions) return null;

  return (
    <div className="exampleQuestionsContainer">
      <VuiText>
        <p className="exampleQuestionsIntro">
          <VuiTextColor color="subdued">{intro}</VuiTextColor>
        </p>
      </VuiText>

      <VuiSpacer size="m" />

      <VuiGrid columns={3}>
        {questions.map((exampleQuestion) => (
          <ExampleQuestion
            key={exampleQuestion}
            onClick={() => onSubmitChat(exampleQuestion)}
            title={exampleQuestion}
          />
        ))}
      </VuiGrid>
    </div>
  );
};
